import {
  AlertModal,
  ErrorModal,
  Flex,
  ListItem,
  Text,
  Toast,
  useOpenModal,
} from '@modusign/design-system';
import { useLabelingDocuments } from '@modusign/openapi-client-external-document';

import { ContentBox } from '@app/features/workspaceManagement';
import useOpenErrorModal from '@app/hooks/useOpenErrorModal';

export default function useUpdateExternalDocumentLabels(options?: { onSuccess?: () => void }) {
  const { createErrorHandler } = useOpenErrorModal();
  const openModal = useOpenModal();

  return useLabelingDocuments({
    mutation: {
      onError: createErrorHandler({ title: '라벨 적용 실패' }),
      onSuccess: ({ error, results }) => {
        const succeededDocumentCount = new Set(results.filter((r) => !r.error).map((r) => r.id))
          .size;
        const description = `${succeededDocumentCount}개 계약에 라벨 변경사항을 적용했습니다.`;

        if (error === 0) {
          Toast.success({ description });
          options?.onSuccess?.();
        } else if (error === results.length) {
          openModal(({ isOpen, onClose }) => (
            <ErrorModal
              error={[
                '선택한 계약 또는 라벨에 대한 권한이 없어 계약에 라벨이 적용되지 않았습니다.',
                '라벨이 적용된 계약이 최대 개수(2,000개)인 경우 라벨이 적용되지 않습니다.',
              ]}
              isOpen={isOpen}
              maxWidth="xs"
              title="라벨 적용 실패"
              onClose={() => {
                onClose();
              }}
            />
          ));
        } else {
          openModal(({ isOpen, onClose }) => (
            <AlertModal
              isOpen={isOpen}
              maxWidth="xs"
              title="라벨 적용 안내"
              variant="completed"
              onClose={() => {
                onClose();
                options?.onSuccess?.();
              }}
            >
              <Flex flexDirection="column" gap={5}>
                <Text>{description}</Text>
                <ContentBox sx={{ gap: 2 }} textAlign="left">
                  <ListItem>
                    선택한 계약 또는 라벨에 대한 권한이 없는 경우 계약에 라벨이 적용되지 않습니다.
                  </ListItem>
                  <ListItem>
                    라벨이 적용된 계약이 최대 개수(2,000개)인 경우 라벨이 적용되지 않습니다.
                  </ListItem>
                </ContentBox>
              </Flex>
            </AlertModal>
          ));
        }
      },
    },
  });
}
